import { render, staticRenderFns } from "./StaffHarmCard.vue?vue&type=template&id=0fbef908&scoped=true"
import script from "./StaffHarmCard.vue?vue&type=script&lang=js"
export * from "./StaffHarmCard.vue?vue&type=script&lang=js"
import style0 from "./StaffHarmCard.vue?vue&type=style&index=0&id=0fbef908&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbef908",
  null
  
)

export default component.exports